import React from 'react';

type Props = {
  error?: string | null
  warning?: string | null
}

export function ErrorWarningMessage(props: Props): React.JSX.Element | null {
  const errorMessage = (
    <span className="form-field__validate form-field__validate--error">{props.error}</span>
  );

  const warningMessage = (
    <span className="form-field__validate form-field__validate--warning">{props.warning}</span>
  );

  if (props.error) {
    return errorMessage;
  } else if (!props.error && props.warning) {
    return warningMessage;
  } else {
    return null;
  }
}
